<div class="bottom-info-component shr-bottominfo-message-component" fxLayout="row" fxLayoutAlign="start center">
    <button (click)="onClicked()" mat-button>
        {{ total > 1 ? 'There are currently (' + total + ') device issues.' : 'There is currently a device issue.' }}
    </button>
</div>
